import panelControl from '@/utils/configs/panelControl';
import panelConfig from '@/utils/configs/panelConfig';
import store from '../../store';
// 弹窗
import NengHaoFloor from '@/components/UE4Panel/NengHaoFloor'
import G5楼 from '@/components/UE4Panel/G5'
import FloorLongCeng from '@/components/UE4Panel/FloorLongCeng'
import HJJCSB from '@/components/UE4Panel/HJJCSB'
import KT from '@/components/UE4Panel/KT'
import Room from '@/components/UE4Panel/Room'
import JGMXCommon from '@/components/UE4Panel/JGMXCommon'
export default class overlayTip {
	static PanelSetting = {
		能耗楼层: {
			com: NengHaoFloor,
			size: [374, 578],
			offset: [-200, -500]
		},
		G5: {
			com: G5楼,
			size: [170, 50],
			offset: [0, 150]
		},
		FloorLongCeng: {
			com: FloorLongCeng,
			size: [273, 50],
			// offset: [800, 0] scale(1)
			offset: [750, 0] //scale(.7)
		},
		Room: {
			com: Room,
			size: [264, 84],
			// offset: [-130, 90]  //4k
			offset: [-130, 20] //2k
			// offset: [-95, 120] //2k
		},
		JGMXCommon: {
			com: JGMXCommon,
			size: [264, 84],
			// offset: [-130, 90]  //4k
			offset: [-130, 20] //2k
		},
		环境监测设备: {
			com: HJJCSB,
			size: [330, 270],
			offset: [0, 0]
		},
		空调: {
			com: KT,
			size: [630, 310],
			offset: [0, 0]
		},
	};
	static prevLayer = ''; // 上一次添加的tip
	static addOverLayTip(res) {
		// 标牌排他
		if (this.prevLayer) {
			panelControl.destroy();
			window.appInstance.uniCall('removeOverlayTip', {
				...this.prevLayer
			});
		}
		let item = panelConfig.getPanelIfon(res);
		let info = JSON.parse(window.sessionStorage.getItem(res.idLayer));
		let ele = null;
		if (res.nameArea) {
			let areaInfo = info.data.filter(item => item.id === res.nameArea);
			ele = panelControl.create(
				res.idObj || res.nameArea,
				this.PanelSetting[item.scatterType].com,
				areaInfo[0]
			);
		} else {
			let rowData = info.data.filter(item => {
				if (item.id == res.idObj) return item;
			});
			ele = panelControl.create(
				res.idObj || res.nameArea,
				this.PanelSetting[item.scatterType].com,
				rowData
			);
		}

		appInstance.uniCall(
			'addOverlayTip', {
			id: res.idObj || res.nameArea,
			url: '',
			size: [ele.clientWidth, ele.clientHeight],
			offset: this.PanelSetting[item.scatterType].offset || [0, 0],
			overlayType: item.layerType,
			isShowClose: false,
			divId: ele.id
		},
			tip => {
				console.log(tip);
			}
		);
		this.prevLayer = {
			overlayType: item.layerType,
			id: res.idObj
		};
	}
	static addAreaOverLayTip(res) {
		let item = panelConfig.getPanelIfon(res);
		let info = JSON.parse(window.sessionStorage.getItem(res.idLayer));
		let ele = null;
		let changjing2 = 1;
		if (res.nameArea) {
			let areaInfo = info.data.filter(item => item.id === res.nameArea);
			ele = panelControl.create(
				res.idObj || res.nameArea,
				this.PanelSetting[item.scatterType].com,
				areaInfo[0],
				changjing2
			);
		} else {
			let rowData = info.data.filter(item => {
				if (item.id == res.idObj) return item;
			});
			ele = panelControl.create(
				res.idObj || res.nameArea,
				this.PanelSetting[item.scatterType].com,
				rowData
			);
		}

		appInstance.uniCall(
			'addOverlayTip', {
			id: res.idObj || res.nameArea,
			url: '',
			size: [ele.clientWidth, ele.clientHeight],
			offset: this.PanelSetting[item.scatterType].offset || [0, 0],
			overlayType: item.layerType,
			isShowClose: false,
			divId: ele.id
		},
			tip => {
				console.log(tip);
			}
		);
		this.prevLayer = {
			overlayType: item.layerType,
			id: res.nameArea
		};
	}
	static removeOverLayTip() {
		if (this.prevLayer) {
			panelControl.destroy();
			window.appInstance.uniCall('removeOverlayTip', {
				...this.prevLayer
			});
			this.prevLayer = '';
		}
	}
	// 散点hover添加标牌
	static addOverLayTipClass(p) {
		// 标牌排他
		if (this.prevLayer) {
			panelControl.destroy();
			window.appInstance.uniCall('removeOverlayTip', {
				...this.prevLayer
			});
		}
		let ele = null;
		ele = panelControl.create(
			p.idObj,
			this.PanelSetting[p.com].com,
			p
		);
		appInstance.uniCall(
			'addOverlayTip', {
			id: p.idObj,
			url: '',
			size: [ele.clientWidth, ele.clientHeight],
			offset: p.idObj == 'shujuzhongxin1' ? [-95, 120] : (this.PanelSetting[p.com].offset || [0, 0]),
			overlayType: p.layerType,
			isShowClose: false,
			divId: ele.id
		},
			tip => {
				console.log(tip,);
			}
		);
		this.prevLayer = {
			overlayType: p.layerType,
			id: p.idObj
		};
	}
	// 模型添加标牌
	static addModelTipClass(res) {
		//获取数据
		// let { id, selected, meta, idLayer } = res;

		if (this.prevModelLayer) {
			panelControl.destroy();
			window.appInstance.uniCall('removeModelTip', {
				...this.prevModelLayer
			});
		}
		const ele = panelControl.create(
			res.id,
			this.PanelSetting['JGMXCommon'].com,
			res,
			'model'
		);

		window.appInstance.uniCall(
			'addModelTip', {
			id: res.id,
			url: '',
			divId: ele.id,
			isShowClose: false,
			// 分辨率原因 此处配置全部缩小2倍
			size: [ele.clientWidth, ele.clientHeight],
			offset: this.PanelSetting['JGMXCommon'].offset || [0, 0]
		},
			res => {
				console.log(res, '楼层机柜添加标牌');
			}
		);

		this.prevModelLayer = {
			id: res.id
		};

		store.commit('setModelTip', this.prevModelLayer);
		switch (this.prevModelLayer.id) {
			case 'C03-004-04_SM_数据服务器_虚拟机':
				store.commit('setLandmarkLayerIdObj', 'C03-004_数据服务器');
				break
			case 'C03-004-04_SM_网络存储服务器':
				store.commit('setLandmarkLayerIdObj', 'C03-004_网络存储服务器');
				break
			case 'C03-004-04_SM_GPU服务器':
				store.commit('setLandmarkLayerIdObj', 'C03-004_GPU服务器');
				break
			default:
				store.commit('setLandmarkLayerIdObj', this.prevModelLayer.id);
		}
	}
	// G5
	static addModelTipG5(res) {
		//获取数据
		// let { id, selected, meta, idLayer } = res;

		if (this.prevModelLayer) {
			panelControl.destroy();
			window.appInstance.uniCall('removeModelTip', {
				...this.prevModelLayer
			});
		}
		const ele = panelControl.create(
			res.id,
			this.PanelSetting['G5'].com,
			res,
			'model'
		);

		window.appInstance.uniCall(
			'addModelTip', {
			id: res.id,
			url: '',
			divId: ele.id,
			isShowClose: false,
			// 分辨率原因 此处配置全部缩小2倍
			size: [ele.clientWidth, ele.clientHeight],
			offset: this.PanelSetting['G5'].offset || [0, 0]
		},
			res => {
				console.log(res);
			}
		);

		this.prevModelLayer = {
			id: res.id
		};
		store.commit('setModelTip', this.prevModelLayer);
	}
	// FloorLongCeng
	static addModelTipFloorLongCeng(res) {
		//获取数据
		// let { id, selected, meta, idLayer } = res;

		if (this.prevModelLayer) {
			panelControl.destroy();
			window.appInstance.uniCall('removeModelTip', {
				...this.prevModelLayer
			});
		}
		const ele = panelControl.create(
			res.id,
			this.PanelSetting['FloorLongCeng'].com,
			res,
			'model'
		);

		window.appInstance.uniCall(
			'addModelTip', {
			id: res.id,
			url: '',
			divId: ele.id,
			isShowClose: false,
			// 分辨率原因 此处配置全部缩小2倍
			size: [ele.clientWidth, ele.clientHeight],
			offset: this.PanelSetting['FloorLongCeng'].offset || [0, 0]
		},
			tip => {
				console.log(res, '添加模型标牌', tip, ele);
			}
		);

		this.prevModelLayer = {
			id: res.id
		};
		store.commit('setModelTip', this.prevModelLayer);
	}
	// 模型删除标牌
	static removeModelTipClass(res) {
		window.appInstance.uniCall('removeModelTip', {
			id: res.id
		});
	}
	// 楼层散点标牌idObj
	static addModelTipFloorRoom(res) {
		//获取数据
		// let { id, selected, meta, idLayer } = res;

		if (this.prevModelLayer) {
			panelControl.destroy();
			window.appInstance.uniCall('removeModelTip', {
				...this.prevModelLayer
			});
		}
		const ele = panelControl.create(
			res.id || res.idObj,
			this.PanelSetting['Room'].com,
			res,
			'model'
		);

		window.appInstance.uniCall(
			'addModelTip', {
			id: res.id || res.idObj,
			url: '',
			divId: ele.id,
			isShowClose: false,
			// 分辨率原因 此处配置全部缩小2倍
			size: [ele.clientWidth, ele.clientHeight],
			offset: this.PanelSetting['Room'].offset || [0, 0]
		},
			res => {
				console.log(res);
			}
		);

		this.prevModelLayer = {
			id: res.id || res.idObj
		};
		store.commit('setLandmarkLayerIdObj', this.prevModelLayer);
	}
}